<template>

    <article
        class="preview-product-price-container ml-3"
        v-if="this.marketing_card.product_mode === 1"
    >   
        <h3>商品資訊設定</h3>
        <span
            class="product-text-container"
            ref="product-text"
            :style="{
                display: 'block',
                boxSizing: 'border-box',
                wordBreak: 'break-word',
                fontSize: marketing_card.product_text_size,
                color: marketing_card.product_text_color,
                lineHeight: '1',
                textAlign: 'left',
                fontFamily: 'Noto Sans TC,Noto Sans JP,sans-serif',
                fontWeight: 'normal !important',
                marginBottom: '5px',
            }"
        >
        {{ marketing_card.product_text }}
        </span>
        <div style="dispaly: inline-block; box-sizing: border-box; text-align: left;">
            <span
                class="discount-price-container"
                ref="discount_price"
                :style="{
                    display: 'block',
                    boxSizing: 'border-box',
                    wordBreak: 'break-word',
                    fontSize:  marketing_card.discount_price_size,
                    color:  marketing_card.discount_price_color,
                    textAlign: 'left',
                    lineHeight: '1',
                    fontFamily: 'Noto Sans TC,Noto Sans JP,sans-serif',
                    fontWeight: 'normal !important',
                }"
            >
            {{ marketing_card.discount_price }}
            </span>
        </div>
    </article>
</template>

<script>

import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        card_data: Object,
        loadOldSettingData: Boolean,
        timeLineMode: String
    },
    name: 'MarketingCardProductInfo',
    components: {

    },
    data() {
        return {
            load_old_setting_data: false,
            old_setting_data: null,
            // local_display: null,
            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            }
        }
    },
    methods: {
        changeStatus: function(param_name,field_name, new_value){
            let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
            tmp[field_name] = new_value
            this.$store.commit(param_name, tmp)
            console.log('after_commit', this.$store.getters[param_name])
        },
    },
    mounted() {
    },
    created() {
        console.log('硬拉',this.marketing_card)
        console.log('硬拉',this.marketing_card.discount_price)
    },
    watch: {
        loadOldSettingData: {
            handler: function(newValue) {
                console.log(newValue);
                console.log(this.timeLineMode);
                console.log('product_mode:',this.oldSettingData)
                if (this.oldSettingData) {
                    this.old_setting_data = JSON.parse(this.oldSettingData.add_column)
                }
                else {
                    this.old_setting_data = this[this.parseKey[this.timeLineMode]]['add_column']
                }
                
                this.load_old_setting_data = newValue
                console.log(this.old_setting_data);
                this.changeStatus('marketing_card','add_column', this.old_setting_data)
            },
            // immediate: true
        },
        timeLineMode: {
            handler: function(newValue) {
                this.old_setting_data = this.oldSettingData !== null ? JSON.parse(this.oldSettingData.add_column) : this[this.parseKey[this.timeLineMode]]['add_column']
                this.load_old_setting_data = newValue
                console.log(this.old_setting_data);
                this.changeStatus('marketing_card','add_column', this.old_setting_data)
            },
            // immediate: true
        },
        load_old_setting_data: {
            handler: function(newValue) {
                if (newValue) {
                    this.load_old_setting_data = newValue 
                }
            },
            // immediate: true
        },
    },
    computed: {
        ...mapState( ['marketing_card'] ),
        ...mapGetters(["oldSettingData",'warmUpCardSetting','activityCardSetting','endUpCardSetting']),
    }
}
</script>

<style scoped>

</style>